import {Component} from '@angular/core';
import {RouterLink} from "@angular/router";

import {appRoutes} from "@numizmat/constants";

import {FooterItem} from "./types/footer-item";
import {LogoComponent} from "../logo/logo.component";

@Component({
  selector: 'nz-footer',
  standalone: true,
  imports: [
    RouterLink,
    LogoComponent
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public items: FooterItem[] = this.initializeItems();

  private initializeItems(): FooterItem[] {
    return [
      {
        title: 'Начало',
        route: appRoutes.home
      },
      {
        title: 'Обяви',
        route: appRoutes.adList
      },
      {
        title: 'Помощен център',
        route: appRoutes.helpInformation
      },
      {
        title: 'Контакт с нас',
        route: appRoutes.contactUs
      },
      {
        title: 'Общи условия',
        route: appRoutes.termsConditions
      }
    ];
  }
}
